import { AttendanceSheetResponseDto } from '@/api.types';
import { DataAmigavel } from '@/shared/utils/datas';

type Props = {
  folha: AttendanceSheetResponseDto;
};

/**
 * Cabeçalho com dados do estagiário, local, supervisor e período de estágio.
 */
export default function AttendanceSheetEstagiarioInfo({ folha }: Props) {
  return (
    <div className="mb-4 col-8">
      <div className="d-flex align-items-center justify-content-between">
        <h4 style={{ fontWeight: 'bold' }}>{folha.estagiario?.nome}</h4>
      </div>

      <h5>{folha.estagio.local}</h5>

      <h5>
        <b>Supervisor:</b> {folha.responsavel?.nome}
      </h5>

      <h5>
        <b>Período de Estágio:</b> {DataAmigavel(folha.estagio.data_inicio_estagio)} a{' '}
        {DataAmigavel(folha.estagio.data_fim_estagio)}
      </h5>
    </div>
  );
}
